import * as React from 'react';
import { useDispatch } from 'react-redux';

import { ENewReviewStep } from '../../types/newReview';
import { ReviewContainer } from '../NewReview/Review';
import { DEFAULT_MODERATION_LINK } from '../../constants/reviews/moderation';
import { useApplicationContext } from '../../utils/applicationContext';
import { Success } from '../../components/FormCommon/Success';
import { Error } from '../../components/FormCommon/Error';
import { addReviewActions } from '../../actions/newReview/addReviewActions';
import { TThunkDispatch } from '../../types/redux';
import { ReviewFlowContainer } from '../DailyrentNewReview/ReviewFlowContainer/ReviewFlowContainer';
import { RatingsContainer } from '../DailyrentNewReview/Rating';

export interface INewReviewModalContentContainerProps {
  step: ENewReviewStep;
  onClose(): void;
}

export const NewReviewModalContentContainer: React.FC<INewReviewModalContentContainerProps> = props => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { config } = useApplicationContext();
  const { step, onClose } = props;
  const moderationUrl = config.get<string>('newbuilding-reviews-frontend.moderationUrl') || DEFAULT_MODERATION_LINK;

  const retry = React.useCallback(() => {
    dispatch(addReviewActions());
  }, [dispatch]);

  switch (step) {
    case ENewReviewStep.FlowSelection: {
      return <ReviewFlowContainer />;
    }
    case ENewReviewStep.Rating: {
      return <RatingsContainer />;
    }
    case ENewReviewStep.Review: {
      return <ReviewContainer />;
    }
    case ENewReviewStep.Success: {
      return <Success type="отзыв" url={moderationUrl} close={onClose} />;
    }
    case ENewReviewStep.Error: {
      return <Error retry={retry} type="Отзыв" />;
    }
    default:
      return null;
  }
};
